import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { getBorder } from 'Components/utils';
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = buildUseStyles('ToggleAttributeButton', (theme) => ({
  root: {
    // Added so buttons don't shift when changing to contained
    ...getBorder(
      theme,
      {
        all: true,
        color: fade(theme.palette.primary.main, 0.5),
      },
    ),
  },
}));

const RoundedToggleAttributeButton = ({
  className,
  label,
  value,
  onChange,
  attrForTest,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const variant = value ? 'contained' : 'outlined';
  const handleToggle = async () => {
    if (value) {
      await onChange('');
    } else {
      await onChange('true');
    }
  };

  return (
    <RoundedButton
      className={classNames(className, classes.root)}
      onClick={handleToggle}
      color={'primary'}
      variant={variant}
      padding={'none'}
      test={`toggle-attribute-button-${attrForTest}`}
    >
      <Typography variant={'subtitle2'} weight={'book'}>
        {label}
      </Typography>
    </RoundedButton>
  );
};

RoundedToggleAttributeButton.defaultProps = {
  className: '',
  label: '',
  onChange: noop,
};

RoundedToggleAttributeButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  attrForTest: PropTypes.string.isRequired,
};

export default RoundedToggleAttributeButton;
